export class BuscaViagensBookingViewModel{
    IdPortoOrigem: number;
    IdPortoDestino: number;
    Modal: string;
    TipoPeriodo: string;
    DataReferencia: Date;
    DataSelecionada: Date;
}